"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _constants = require("../constants");

var _parameter = _interopRequireDefault(require("../common/errors/parameter"));

var StatsUtil = {};

StatsUtil.generateSingularOptions = function (senderReceiver, config, meeting, name) {
  var options = {};
  options[name] = {};
  options[name][senderReceiver.correlate] = senderReceiver;
  StatsUtil.generateOptions(options, config, meeting);
};

StatsUtil.generateOptions = function (options, config, meeting) {
  if (!options || !config || !meeting) {
    throw new _parameter.default('stats/util->validateInitialization#options, config, and meeting must be provided to execute getStats');
  }

  StatsUtil.configOptions(meeting, config, options, _constants.STATS.SENDERS);
  StatsUtil.configOptions(meeting, config, options, _constants.STATS.RECEIVERS);
};

StatsUtil.configOptions = function (meeting, config, options, name) {
  if (options[name]) {
    (0, _forEach2.default)(options[name], function (type) {
      if (!type.correlate) {
        throw new _parameter.default("stats/util->validateInitialization#each ".concat(type, " must be provided with a correlate as audio OR video OR share."));
      }

      if (!config[name][type.correlate]) {
        return;
      }

      var typeConfig = config[name][type.correlate];
      var media = meeting[typeConfig.parent][typeConfig.peerConnection];
      var filter = media[typeConfig.transceiver][typeConfig.child];
      (0, _assign.default)(type, {
        media: media,
        filter: filter,
        name: typeConfig.name
      });
    });
  }
};

var _default = StatsUtil;
exports.default = _default;
//# sourceMappingURL=util.js.map
